import PartnersCommisionsHeader from '../PartnersCommissionsHeader/PartnersCommissionsHeader.vue'
export default {
  components: {
    PartnersCommisionsHeader
  }
}
